// Forbidden Map Manager - 禁地地图管理器
import { gainXp } from '../realms';
import { StateManager } from '../state';

class ForbiddenMapManager {
  constructor(stateManager) {
    this.stateManager = stateManager;
  }

  // 生成禁地地图
  generateMap() {
    const state = this.stateManager.getState();

    // 随机生成地图大小 10-20
    state.mapSize = 10 + Math.floor(Math.random() * 11);
    // 初始化地图网格，所有位置设为'safe'或'danger'或'opportunity'
    state.mapGrid = [];
    for (let y = 0; y < state.mapSize; y++) {
      state.mapGrid[y] = [];
      for (let x = 0; x < state.mapSize; x++) {
        const r = Math.random();
        if (r < 0.6) state.mapGrid[y][x] = 'safe'; // 安全区域
        else if (r < 0.8) state.mapGrid[y][x] = 'danger'; // 危险
        else state.mapGrid[y][x] = 'opportunity'; // 机缘
      }
    }
    // 宝藏位置在地图深处（中心附近随机）
    const center = Math.floor(state.mapSize / 2);
    state.treasurePos.x = center + Math.floor(Math.random() * 5) - 2;
    state.treasurePos.y = center + Math.floor(Math.random() * 5) - 2;
    state.treasurePos.x = Math.max(0, Math.min(state.mapSize - 1, state.treasurePos.x));
    state.treasurePos.y = Math.max(0, Math.min(state.mapSize - 1, state.treasurePos.y));
    state.mapGrid[state.treasurePos.y][state.treasurePos.x] = 'treasure';
    // 玩家起始位置在边缘
    state.playerPos.x = Math.floor(Math.random() * state.mapSize);
    state.playerPos.y = Math.floor(Math.random() * state.mapSize);
    // 确保起始位置不是宝藏
    while (state.playerPos.x === state.treasurePos.x && state.playerPos.y === state.treasurePos.y) {
      state.playerPos.x = Math.floor(Math.random() * state.mapSize);
      state.playerPos.y = Math.floor(Math.random() * state.mapSize);
    }
    // 初始化探索记录，包含起始位置
    state.exploredCells = [`${state.playerPos.x},${state.playerPos.y}`];

    this.stateManager.updateState({
      mapSize: state.mapSize,
      mapGrid: state.mapGrid,
      treasurePos: state.treasurePos,
      playerPos: state.playerPos,
      exploredCells: state.exploredCells
    });
  }

  // 移动玩家
  movePlayer(dx, dy) {
    const state = this.stateManager.getState();
    const newX = state.playerPos.x + dx;
    const newY = state.playerPos.y + dy;
    if (newX < 0 || newX >= state.mapSize || newY < 0 || newY >= state.mapSize) {
      return ['无法移动到那个方向，超出地图边界。'];
    }

    state.playerPos.x = newX;
    state.playerPos.y = newY;
    // 记录探索过的格子
    const cellKey = `${state.playerPos.x},${state.playerPos.y}`;
    if (!state.exploredCells.includes(cellKey)) {
      state.exploredCells.push(cellKey);
    }

    // 检查当前位置的事件
    const cell = state.mapGrid[state.playerPos.y][state.playerPos.x];
    let messages = [];

    if (cell === 'treasure') {
      // 找到宝藏，获得奖励并退出地图
      this.stateManager.addItemToBag('禁地宝藏');
      this.stateManager.exitForbiddenMap();
      messages = ['恭喜！你找到了禁地宝藏！获得禁地宝藏一件。', '已自动退出禁地。'];
    } else if (cell === 'danger') {
      // 遭遇危险
      const damage = 10 + Math.floor(Math.random() * 20);
      const newQi = Math.max(0, state.qi - damage);
      this.stateManager.updateAttribute('qi', newQi);
      messages = [`遭遇危险！受到 ${damage} 点伤害。当前气血：${newQi}/${state.maxQi}`];
    } else if (cell === 'opportunity') {
      // 获得机缘
      const r = Math.random();
      if (r < 0.4) {
        messages = ['获得机缘！修为提升。', ...gainXp(state, 30 + Math.floor(Math.random() * 20))];
      } else if (r < 0.7) {
        this.stateManager.addItemToBag('灵草');
        messages = ['获得机缘！发现一株灵草。'];
      } else {
        this.stateManager.increaseAttribute('divineSenseStrength', 1);
        messages = [`获得机缘！神识强度提升1点。当前神识强度：${state.divineSenseStrength + 1}`];
      }
    } else {
      messages = ['安全移动，没有遇到特殊事件。'];
    }

    this.stateManager.updateState({
      playerPos: state.playerPos,
      exploredCells: state.exploredCells
    });

    return messages;
  }

  // 扫描区域
  scanArea() {
    const state = this.stateManager.getState();
    const range = Math.floor(state.divineSenseStrength / 100) + 1; // 神识强度越高，扫描范围越大
    const results = [];
    const scannedCells = [...state.scannedCells]; // 复制现有扫描细胞
    for (let dy = -range; dy <= range; dy++) {
      for (let dx = -range; dx <= range; dx++) {
        const x = state.playerPos.x + dx;
        const y = state.playerPos.y + dy;
        if (x >= 0 && x < state.mapSize && y >= 0 && y < state.mapSize) {
          const cellKey = `${x},${y}`;
          if (!scannedCells.includes(cellKey)) {
            scannedCells.push(cellKey); // 添加到扫描细胞列表
          }
          const cell = state.mapGrid[y][x];
          if (cell === 'safe' || cell === 'treasure') {
            results.push(`(${dx},${dy}): 安全`);
          } else if (cell === 'danger') {
            results.push(`(${dx},${dy}): 危险`);
          } else if (cell === 'opportunity') {
            results.push(`(${dx},${dy}): 机缘`);
          }
        }
      }
    }
    // Store scan results for map display, but don't show coordinates in console
    this.stateManager.updateState({ lastScanResults: results, scannedCells: scannedCells });
    return ['神识扫描完成，地图已更新。'];
  }

  // 退出禁地
  exitMap() {
    const state = this.stateManager.getState();
    // 计算完成度
    const exploredCount = state.exploredCells.length;
    const totalCells = state.mapSize * state.mapSize;
    const completion = Math.round((exploredCount / totalCells) * 100);
    // 更新历史最高
    if (completion > state.maxExplorationCompletion) {
      this.stateManager.updateAttribute('maxExplorationCompletion', completion);
    }
    this.stateManager.updateState({ scannedCells: [] }); // 清空扫描记录
    this.stateManager.exitForbiddenMap();
    return [`已退出禁地，返回正常模式。`, `本次禁地探索完成度：${completion}% (${exploredCount}/${totalCells})`, `历史最高完成度：${Math.max(completion, state.maxExplorationCompletion)}%`];
  }

  // 获取地图信息
  getMapInfo() {
    const state = this.stateManager.getState();
    return {
      size: state.mapSize,
      playerPos: state.playerPos,
      treasurePos: state.treasurePos,
      exploredCells: state.exploredCells,
      completion: Math.round((state.exploredCells.length / (state.mapSize * state.mapSize)) * 100)
    };
  }
}

export default ForbiddenMapManager;
